import React from 'react';

export interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  status?: React.ReactNode;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
}

/**
 * Shared section header: title/subtitle/action/status pattern for profile sections.
 * Mirrors PageHeader but uses h2 for section hierarchy.
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  action,
  status,
  icon: Icon,
  className = ''
}) => (
  <header
    className={`flex flex-col sm:flex-row sm:items-start sm:justify-between sm:gap-4 ${className}`}
    aria-labelledby="section-title"
  >
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        {Icon && (
          <div className="flex-shrink-0">
            <Icon className="w-6 h-6 text-primary-500" />
          </div>
        )}
        <h2
          id="section-title"
          className="text-xl font-bold text-primary-500 tracking-tight"
        >
          {title}
        </h2>
        {status && (
          <span className="inline-flex items-center shrink-0">
            {status}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="mt-1 text-sm text-primary-600">
          {subtitle}
        </p>
      )}
    </div>
    {action && (
      <div className="mt-4 sm:mt-0 shrink-0">
        {action}
      </div>
    )}
  </header>
);

export default SectionHeader;
